import axios from "axios";

export interface ReportResp {
   id: string;
   createdAt: string;
   updatedAt: string;
   key: string;
   category: string | null;
   title: string;
   subtitle: string | null;
   internalDescription: string | null;
   icon: string | null;
   datePublished: string | null;
   published: boolean;
   readTimeInMinutes: number | null;
   socialShareText: string | null;
   mainHeaderImgSrc: string | null;
   optionalHeaderImg_768w: string | null;
   squareImg_560w: string | null;
   references: { title: string; url: string }[] | null;
   relatedReports: string[] | null;
   information: { SNP: { title: string; text: string } } | null;
   snpInfo: object;
   content: object | null;
   complexityValue: string | null;
   heritability: string | null;
   cardContent: {
      color: string;
      rows: {
         type: string;
         content: any;
         largeScreenPosition: "flexLeft" | "flexRight" | "full";
      }[];
   } | null;
}

export default class ReportsApi {
   public static getOneByKey = async (key: string): Promise<ReportResp> => {
      const response = await axios.get(`/reports/by/key/${key}`);

      return response.data?.data;
   };
}
